import React from "react";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { Brain, Server, Layout, Database, Bug, Cloud, Cpu } from "lucide-react";

const ICONS = { brain: Brain, server: Server, layout: Layout, database: Database, bug: Bug, cloud: Cloud };

export default function Skills({ skills }) {
    const defaultSkills = [
        { id: "ai-ml", group: "AI / ML", icon: "brain", items: ["LLMs", "RAG", "Vector Search", "Semantic Search", "SQL Agents", "Prompt Engineering", "LangChain"] },
        { id: "backend", group: "Backend", icon: "server", items: ["FastAPI", "Python", "Node.js", "REST APIs", "Redis", "Celery"] },
        { id: "frontend", group: "Frontend", icon: "layout", items: ["React", "Next.js", "TypeScript", "TailwindCSS", "Framer Motion"] },
        { id: "database", group: "Database", icon: "database", items: ["PostgreSQL", "MongoDB", "Qdrant", "Redis", "SQL"] },
        { id: "testing", group: "Testing & QA", icon: "bug", items: ["Playwright", "Selenium", "API Testing", "Database Testing", "Test Automation", "Postman"] },
        { id: "devops", group: "DevOps / Cloud", icon: "cloud", items: ["Docker", "Vercel", "CI/CD", "Git", "Linux"] },
    ];

    const displaySkills = skills?.length ? skills : defaultSkills;

    return (
        <section className="max-w-6xl mx-auto px-5 py-24 md:py-32">
            <SectionHeading 
                id="skills" 
                index="03 / Skills" 
                subtitle="Toolbox" 
                title="A stack tuned for AI, quality and scale." 
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {displaySkills.map((s, i) => {
                    const Icon = ICONS[s.icon] || Cpu;
                    return (
                        <Reveal key={s.id || s.group || i} delay={i * 0.06} className="flex flex-col">
                            <div className="group glass rounded-3xl p-7 h-full flex flex-col justify-between hover:-translate-y-1.5 transition-all duration-300 relative overflow-hidden border border-border/70 hover:border-primary/40 shadow-sm hover:shadow-xl" data-testid={`skill-${s.group}`}>
                                <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-primary/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
                                <div className="relative">
                                    <div className="w-12 h-12 rounded-2xl grid place-items-center bg-primary/10 border border-primary/20 text-primary mb-5 group-hover:scale-110 group-hover:bg-primary group-hover:text-white transition-all duration-300 shadow-sm">
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <h3 className="font-display text-xl font-bold mb-5 text-foreground group-hover:text-primary transition-colors tracking-tight">
                                        {s.group}
                                    </h3>
                                    <div className="flex flex-wrap gap-2.5">
                                        {(s.items || []).map((it) => (
                                            <span 
                                                key={it} 
                                                className="text-xs sm:text-sm font-mono px-3.5 py-1.5 rounded-full bg-secondary/80 text-foreground/90 border border-border/60 hover:border-primary/60 hover:bg-primary/15 hover:text-primary transition-all cursor-default shadow-xs"
                                            >
                                                {it}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
